export class OurAppsBannerResponse extends Array<OurAppsBannerResponse> {
  constructor() {
    super();
    this.id = 0;
    this.BannerimageUrl = "";
  }
  public id: number;
  public BannerimageUrl: string;
}
